/**
 * Contenu SEO localisé pour chaque page principale.
 * Optimisé pour les requêtes longue traîne européennes (drone + pays + réglementation).
 *
 * Convention : description ≤ 160 caractères, title ≤ 65 caractères.
 */

export const LANDING_SEO = {
  fr: {
    title: 'Drone Maps — Conformité Réglementaire Drone Europe',
    description:
      "Planifiez vos missions drone en Europe en conformité avec EU 2019/947. Carte des zones interdites, analyse réglementaire automatique, rapports PDF.",
    keywords:
      'réglementation drone, EU 2019/947, conformité UAS, carte drone Europe, zones interdites drone, DGAC, DFS, AESA, vol drone professionnel, catégorie Open, catégorie Specific, NOTAM drone, ED-269, geozones, télépilote drone, AlphaTango, déclaration mission drone',
  },
  en: {
    title: 'Drone Maps — European Drone Regulation Compliance',
    description:
      'Plan compliant drone missions across Europe under EU 2019/947. No-fly zones map, automated regulatory analysis and PDF mission reports.',
    keywords:
      'drone regulation Europe, EU 2019/947, UAS compliance, drone no-fly zones, EASA, Open category, Specific category, drone flight planning, ED-269 geozones, NOTAM drone, professional drone pilot, drone airspace map',
  },
  de: {
    title: 'Drone Maps — EU-Drohnen-Konformität für Profis',
    description:
      'Planen Sie EU-konforme Drohnenmissionen (EU 2019/947). Karte der Flugverbotszonen, automatische Vorschriftenanalyse und PDF-Missionsberichte.',
    keywords:
      'Drohnenverordnung, EU 2019/947, EASA, UAS Konformität, Flugverbotszone Drohne, DFS DIPUL, Open-Kategorie, Specific-Kategorie, Drohnenflug planen, ED-269 Geozonen, NOTAM Drohne, Berufsdrohnenpilot',
  },
  it: {
    title: 'Drone Maps — Conformità Normativa Droni in Europa',
    description:
      "Pianifica missioni drone in Europa conformi a EU 2019/947. Mappa zone interdette, analisi normativa automatica e report PDF di missione.",
    keywords:
      'regolamento droni, EU 2019/947, ENAC, AESA, zone interdette droni, categoria Open, categoria Specific, pianificazione volo drone, ED-269, NOTAM drone, pilota drone professionale, D-Flight',
  },
  es: {
    title: 'Drone Maps — Cumplimiento Normativo Dron en Europa',
    description:
      'Planifica misiones de dron en Europa conforme a EU 2019/947. Mapa de zonas restringidas, análisis normativo automático y reportes PDF.',
    keywords:
      'regulación dron, EU 2019/947, AESA, EASA, zonas prohibidas dron, categoría Open, categoría Specific, planificación vuelo dron, ED-269 geozonas, NOTAM dron, piloto dron profesional, ENAIRE',
  },
};

export const FAQ_SEO = {
  fr: {
    title: 'FAQ Réglementation Drone — Catégories Open & Specific',
    description:
      'Questions fréquentes sur la réglementation drone européenne : catégories Open & Specific, classes CE, zones interdites, autorisations DGAC, EU 2019/947.',
    keywords:
      'FAQ drone, réglementation drone France, catégorie Open A1 A2 A3, catégorie Specific, classes CE drone, AlphaTango, DGAC autorisation drone, formation télépilote, zone CTR drone',
  },
  en: {
    title: 'Drone Regulation FAQ — Open & Specific Categories Explained',
    description:
      'Frequently asked questions about European drone regulation: Open & Specific categories, CE classes, no-fly zones, EU 2019/947, registration, authorisation.',
    keywords:
      'drone FAQ, drone regulation Europe, Open category A1 A2 A3, Specific category, drone CE class, EASA authorisation, drone registration, drone training, CTR airspace drone',
  },
  de: {
    title: 'Drohnen-FAQ — Open- & Specific-Kategorie erklärt',
    description:
      'Häufig gestellte Fragen zur EU-Drohnenverordnung: Kategorien Open & Specific, CE-Klassen, Flugverbotszonen, EU 2019/947, Registrierung, Zulassung.',
    keywords:
      'Drohne FAQ, Drohnenverordnung Deutschland, Open-Kategorie A1 A2 A3, Specific-Kategorie, CE-Klasse Drohne, DFS, LBA, EASA, Drohnenregistrierung, CTR Drohne',
  },
  it: {
    title: 'FAQ Droni — Categorie Open e Specific Spiegate',
    description:
      'Domande frequenti sul regolamento droni europeo: categorie Open e Specific, classi CE, zone interdette, EU 2019/947, registrazione, autorizzazione.',
    keywords:
      'FAQ drone, regolamento drone Italia, categoria Open A1 A2 A3, categoria Specific, classe CE drone, ENAC, D-Flight, formazione pilota drone, CTR drone',
  },
  es: {
    title: 'FAQ Dron — Categorías Open y Specific Explicadas',
    description:
      'Preguntas frecuentes sobre la regulación europea de drones: categorías Open y Specific, clases CE, zonas prohibidas, EU 2019/947, registro, autorización.',
    keywords:
      'FAQ dron, regulación dron España, categoría Open A1 A2 A3, categoría Specific, clase CE dron, AESA, ENAIRE, formación piloto dron, CTR dron',
  },
};

export const BLOG_SEO = {
  fr: {
    title: 'Blog Drone — Actualités, Guides & Réglementation Européenne',
    description:
      'Articles, guides et actualités pour les télépilotes : réglementation européenne, retours d’expérience, classes drone, autorisations DGAC, conseils pratiques.',
    keywords:
      'blog drone, actualité drone Europe, guide télépilote, EU 2019/947 nouveautés, drone professionnel, autorisation vol drone, classe CE, formation pilote drone',
  },
  en: {
    title: 'Drone Blog — News, Guides & European Regulation',
    description:
      'Articles, guides and news for remote pilots: European regulation, CE class updates, drone authorisations, hands-on tutorials and best practices.',
    keywords:
      'drone blog, drone news Europe, remote pilot guide, EU 2019/947 updates, professional drone, drone authorisation, CE class drone, pilot training',
  },
  de: {
    title: 'Drohnen-Blog — News, Guides & EU-Verordnung',
    description:
      'Artikel, Leitfäden und News für Fernpiloten: EU-Verordnung, CE-Klassen-Updates, Drohnen-Genehmigungen, Tutorials und Best Practices.',
    keywords:
      'Drohnen-Blog, Drohnen-News Europa, Fernpilot Leitfaden, EU 2019/947 Update, Profi-Drohne, Drohnen-Genehmigung, CE-Klasse, Pilotenschulung',
  },
  it: {
    title: 'Blog Drone — Notizie, Guide & Regolamento UE',
    description:
      'Articoli, guide e notizie per piloti drone: regolamento UE, aggiornamenti classi CE, autorizzazioni drone, tutorial e best practice.',
    keywords:
      'blog drone, notizie drone Europa, guida pilota drone, EU 2019/947 aggiornamento, drone professionale, autorizzazione drone, classe CE, formazione pilota',
  },
  es: {
    title: 'Blog Dron — Noticias, Guías y Regulación Europea',
    description:
      'Artículos, guías y noticias para pilotos de dron: regulación europea, actualizaciones clases CE, autorizaciones, tutoriales y buenas prácticas.',
    keywords:
      'blog dron, noticias dron Europa, guía piloto dron, EU 2019/947 actualización, dron profesional, autorización dron, clase CE, formación piloto',
  },
};

/**
 * Organisation Schema.org globale (à injecter une fois sur la Landing).
 */
export const ORGANIZATION_JSONLD = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': 'https://drone-maps.eu/#organization',
  name: 'Drone Maps',
  url: 'https://drone-maps.eu',
  logo: 'https://drone-maps.eu/logo.png',
  description:
    'Plateforme SaaS B2B de conformité réglementaire pour les opérateurs de drones en Europe.',
  contactPoint: [
    {
      '@type': 'ContactPoint',
      url: 'https://drone-maps.eu/contact',
      contactType: 'customer support',
      availableLanguage: ['French', 'English', 'German', 'Italian', 'Spanish'],
    },
  ],
  areaServed: [
    'France', 'Germany', 'Belgium', 'Netherlands', 'Luxembourg',
    'Spain', 'Italy', 'Switzerland', 'Austria', 'Czechia', 'Slovakia',
    'Denmark', 'Ireland', 'Estonia', 'Cyprus', 'Poland', 'Portugal', 'Iceland',
  ],
  sameAs: [
    'https://www.linkedin.com/company/drone-maps-europe',
  ],
};

/**
 * Construit un BreadcrumbList Schema.org à partir d'une liste [{name, url}].
 */
export function buildBreadcrumbJsonLd(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: item.name,
      item: item.url,
    })),
  };
}
